import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CompanyService from "../../../../services/catalogs/CompanyService";

export const REQUEST_CREATE_COMPANY = "REQUEST_CREATE_COMPANY";
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";
export const CREATE_COMPANY_ERROR = "CREATE_COMPANY_ERROR";

function requestCreateCompany() {
  return {
    type: REQUEST_CREATE_COMPANY,
  };
}

function createCompanySuccess(json) {
  return {
    type: CREATE_COMPANY_SUCCESS,
    message: json.data,
  };
}

function createCompanyError(json) {
  return {
    type: CREATE_COMPANY_ERROR,
    error: json.data,
  };
}

export function createCompany(payload) {
  return (dispatch) => {
    dispatch(requestCreateCompany());
    return CompanyService.postCompany(payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(createCompanySuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createCompany(payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(createCompanyError(json.data));
      }
    });
  };
}
